import apiClient from '../apiClient';
import { POST_USER_URL } from '../apiUrl';

const postUserApi = data => {
  return apiClient.post(POST_USER_URL, data);
};

export default postUserApi;
